import React, {useEffect, useMemo, useState} from "react";
import {Tabs, Tab} from '@material-ui/core';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {format} from 'date-fns'

import TabPanel from "../../core/TablPanel";
import {Card, CardBody} from "../../../../_metronic/_partials/controls";
import {BalanceTabContent} from "../../modules/BalaceTabContent";
import {useBalancesUIContext} from "../../../contexts/BalancesUIContext";
import {fetchSalesList, fetchBalanceSummary} from "../../../../redux/modules/balances/actions";
import * as uiHelpers from "../../modules/BalaceTabContent/ui.helpers";

export function BalanceContainer() {
  const context = useBalancesUIContext();
  const dispatch = useDispatch();
  const [tabIndex, setIndex] = useState(0);
  const [date, setDate] = useState(format(new Date(), 'yyyy-MM'));
  const {columns, tabs} = uiHelpers;

  const {queryParams, handleTabChange, handleChangeDate} = useMemo(() => ({
    queryParams: context.queryParams,
    handleTabChange: (event, newValue) => setIndex(newValue),
    handleChangeDate: (_date) => setDate(_date),
  }), [context]);

  const {balanceStore} = useSelector(state => ({
    balanceStore: state.balances,
  }), shallowEqual);

  const {balanceSummary, totalCount, salesList, listLoading} = balanceStore;

  useEffect(() => {
    const query = {...queryParams, filter: {balanceStatus: tabs[tabIndex].key}}
    dispatch(fetchBalanceSummary(date, query));
    dispatch(fetchSalesList(date, query));
  }, [queryParams, tabIndex, date, tabs, dispatch]);

  return (
    <Card className="flex-grow-1">
      <Tabs
        centered
        textColor="primary"
        indicatorColor="primary"
        value={tabIndex}
        onChange={handleTabChange}
      >
        {tabs.map(tab => (
          <Tab
            label={<span className="py-3" style={{fontSize: 20}}>{tab.label}</span>}
            key={tab.key}
          />
        ))}
      </Tabs>

      <CardBody>
        <TabPanel value={tabIndex} index={tabIndex}>
          <BalanceTabContent
            currentDate={date}
            onChangeDate={handleChangeDate}
            columns={columns}
            salesList={salesList}
            totalCount={totalCount}
            listLoading={listLoading}
            balanceSummary={balanceSummary}
          />
        </TabPanel>
      </CardBody>
    </Card>
  );
}
